import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Represents the filterBlockchainNetworksView class, extending JetView.
 */
export default class filterCryptoBlockchainView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo', // Dropdown for selecting cryptoCurrencies
                            name: 'CryptoCurrencyId',
                            localId: 'cryptoCurrencyId:combo',
                            label: _('Criptomonedas'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Digita para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data fetching for cryptoCurrencies
                                        var vthis = this;
                                        if (text.length <= 2) {
                                            vthis.clearAll();
                                            return;
                                        }
                                        if (text.length > 2) {
                                            // Trigger API call if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GetCryptoSummary',
                                                    '{"Filter":"' + text + '", "State": 1}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                vthis.clearAll();
                                                                // Check for errors in response
                                                                vthis.parse(resp.Data); // Populate dropdown with data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Dropdown for selecting blockchain networks
                            name: 'BlockchainIdNetwork',
                            localId: 'blockchainIdNetwork:combo',
                            label: _('Red Blockchain'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Digita para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data fetching for blockchain networks
                                        var vthis = this;
                                        if (text.length <= 2) {
                                            vthis.clearAll();
                                            return;
                                        }
                                        if (text.length > 2) {
                                            // Trigger API call if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BlockChainSelect',
                                                    '{"Filter":"' + text + '", "State": 1}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                vthis.clearAll();
                                                                // Check for errors in response
                                                                vthis.parse(resp.Data); // Populate dropdown with data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        };

        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Rich select for activation status
                            name: 'State',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all states
                                { id: 'A', value: _('Activa') }, // Option for activated
                                { id: 'I', value: _('Inactiva') }, // Option for desactivated
                            ],
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };

        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 70 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Left section with activation status selector
                },
            ],
        };

        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for advanced filters
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Upper section for advanced filters
                            },
                        },
                    ],
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to add cryptoCurrency to blockchain network
                            value: _('Asociar Cripto + Red'), // Localized button text
                            type: 'form',
                            width: screen === 'small' ? 0 : 200, // Conditional width based on screen size
                            minWidth: 220,
                            hidden: !devConfig.getPermAction('cryptoNetworksAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-categoriesProductsAdd',
                            click: () => {
                                this.app.callEvent('addCryptoBlockchain:button', [[]]); // Event to add cryptoCurrency to blockchain network
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Limpiar'), // Button label for clearing inputs
                            width: screen === 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter cryptoCurrencies
                            value: _('Consultar'), // Localized button text
                            type: 'form',
                            width: screen === 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('cryptosBlockchain:filter', [filterdata]); // Event to filter cryptoCurrencies
                                console.log(filterdata); // Log filter data
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Initial state of the accordion
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Main layout of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements based on screen width
                $$('grav2').hide();
            }
        });
    }
}

// FILE DOCUMENTED
